import {
  COMPANIES_REQUEST_FAIL,
  COMPANIES_REQUEST_SUCCESS,
  COMPANIES_SEARCH_REQUEST_FAIL,
  COMPANIES_SEARCH_REQUEST_SUCCESS
} from '../action.types'
import initialState from '../initial.state'

export default function(state = initialState.companies, action) {
  switch (action.type) {
    case COMPANIES_REQUEST_SUCCESS:
      return { ...action.payload }
    case COMPANIES_REQUEST_FAIL:
      return state
    case COMPANIES_SEARCH_REQUEST_SUCCESS:
      return [...action.payload]
    case COMPANIES_SEARCH_REQUEST_FAIL:
      return state
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/company/companies.reducer.js